import { fileUpload, getRequest, postRequest } from './request'

//获取DIAL列表
export function getDialList (page, size, model) {
  return getRequest('/dial/list', {
    'page': page,
    'size': size,
    'model':model
  })
}

// 上传表盘文件
export function createDial (dialForm) {
  return fileUpload('/dial/create', dialForm)
}

// 编辑表盘文件
export function editDial (dialForm) {
  return fileUpload('/dial/update', dialForm)
}
// //获取DIAL文件URL
// export function getDialFileUrl (fileName) {
//   return getRequest('/dial/file/url', { 'fileName': fileName })
// }

//删除DIAL
export function deleteDial (data) {
  return postRequest('/dial/delete', data)
}

// export function createDial (dialForm) {
//   return fileUpload('/dial/create', dialForm)
// }

// export function editDial (dialForm) {
//   return postRequest('/dial/edit', dialForm)
// }


// //发送通知
// export  function  sendNotify(dialId,snList,versionList) {
//   return postRequest('/dial/notify', {
//     'dialId': dialId,
//     'snNumbers': snList,
//     'versions': versionList
//   })
// }

// //获取所有版本号
// export function getVersion (dialId) {
//   return getRequest('/dial/versions', {
//     'version': dialId,
//   })
// }

// //获取所有sn号
// export function getSN () {
//   return getRequest('/project/snnumbers', {
//   })
// }
